import { queryOptions } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

export type UseLoanInfoResponse = Awaited<
  ReturnType<typeof api.getLoansLoanpageinfo>
>;

function getLoanInfoQuery(contractId: string, opts: RequestOpts = {}) {
  const queryKey = ['getLoanInfo', contractId];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      if (!contractId) {
        throw new TypeError('Contract ID is required');
      }
      return api.getLoansLoanpageinfo(contractId, { ...opts, signal });
    },
    staleTime: ms('5m'),
    gcTime: ms('10m'),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchLoanInfoQuery(
  contractId: string,
  opts: RequestOpts = {},
) {
  return queryClient.fetchQuery(getLoanInfoQuery(contractId, opts));
}
